{
  "name": "@homer.core/cart",
  "version": "1.21.1",
  "type": "module",
  "private": false,
  "config": {},
  "main": "./dist/index.js",
  "module": "./src/index.js",
  "exports": {
    ".": "./src/index.js",
    "./package.json": "./package.json"
  },
  "scripts": {},
  "dependencies": {
    "@homer.adapter/deepobjectdiff": "*",
    "@homer.api/homer": "*",
    "@homer.core/application": "*",
    "@homer.core/channel": "*",
    "@homer.core/emitter": "*",
    "@homer.core/page": "*",
    "@homer.core/scheduler": "*",
    "@homer.core/storage.cookie": "*",
    "@homer.core/storage.local": "*",
    "@homer.core/user": "*"
  },
  "devDependencies": {},
  "requires": [],
  "loads": []
}
